import React, { useState } from 'react';
import { Header } from './components/Header';
import { PageNav, Page } from './components/PageNav';
import { ScorecardView } from './components/ScorecardView';
import { CareerView } from './components/CareerView';
import { PointSystem } from './components/PointSystem';
import { AdminView } from './components/AdminView';
import { LoanFilesPanel } from './components/LoanFilesPanel';
import { CallsPanel } from './components/CallsPanel';
import { BonusQualification } from './components/BonusQualification';
import { LoanStage, Scope } from './data/loans';
import { useScreenInit } from './useScreenInit.js';
import { getOfficer, OfficerData } from './data/officers';
export function App() {
  const screenInit = useScreenInit();
  const [page, setPage] = useState<Page>(screenInit?.page as Page ?? 'scorecard');
  const [selectedOfficer, setSelectedOfficer] = useState('John Davis');
  const officer = getOfficer(selectedOfficer);
  const [panelOpen, setPanelOpen] = useState(false);
  const [panelStage, setPanelStage] = useState<LoanStage | null>(null);
  const [panelScope, setPanelScope] = useState<Scope>('mtd');
  const [panelSpeedBonusOnly, setPanelSpeedBonusOnly] = useState(false);
  const [hasEnteredDashboard, setHasEnteredDashboard] = useState(false);
  const [callsPanelOpen, setCallsPanelOpen] = useState(false);
  const [callsMetric, setCallsMetric] = useState<'dials' | 'answer_rate'>('dials');
  const [callsScope, setCallsScope] = useState<'today' | 'mtd'>('mtd');
  const openPanel = (stage: LoanStage | null, scope: Scope, speedBonusOnly = false) => {
    setPanelStage(stage);
    setPanelScope(scope);
    setPanelSpeedBonusOnly(speedBonusOnly);
    setPanelOpen(true);
  };
  const openCallsPanel = (metric: 'dials' | 'answer_rate', scope: 'today' | 'mtd') => {
    setCallsMetric(metric);
    setCallsScope(scope);
    setCallsPanelOpen(true);
  };
  return <div className="min-h-screen bg-gray-100 flex flex-col font-sans" data-id="element-0" data-mp="stkoy7imcq4d">
      <Header loanOfficer={selectedOfficer} onLoanOfficerChange={officer => {
      setSelectedOfficer(officer);
      setHasEnteredDashboard(false); // Reset to entry screen when changing officer
    }} data-id="element-1" data-mp="3688rpx40wyp" />

      {!hasEnteredDashboard ? <main className="flex-1 p-4 md:p-6 lg:p-8 max-w-[1000px] mx-auto w-full flex flex-col justify-center" data-id="element-2" data-mp="d2bh5dik1ru3">
          <div className="text-center mb-8" data-id="element-3" data-mp="3gleaym6kt9gr">
            <h1 className="text-2xl md:text-3xl font-extrabold text-[#0a1e5e] mb-2" data-id="element-4" data-mp="3gm66jx06b771">
              Welcome back, {selectedOfficer.split(' ')[0]}
            </h1>
            <p className="text-gray-500" data-id="element-5" data-mp="3qaxulu2457co">
              Click your scorecard to view your full dashboard and loan files.
            </p>
          </div>
          <BonusQualification currentPoints={officer.monthlyPoints} goalPoints={officer.monthlyGoal} unitsClosed={officer.unitsClosed} onClick={() => setHasEnteredDashboard(true)} data-id="element-6" data-mp="3lj6ao2dgpzvi" />
        </main> : <>
          <PageNav page={page} onChange={setPage} data-id="element-7" data-mp="18czlufkf77kw" />
          <main className="flex-1 p-4 md:p-6 lg:p-8 max-w-[1600px] mx-auto w-full" data-id="element-8" data-mp="1d4hp5a9x1k91">
            {page === 'scorecard' && <ScorecardView officer={officer} onTileClick={(stage, scope) => openPanel(stage, scope)} onSpeedBonusClick={scope => openPanel(null, scope, true)} onViewAllFiles={() => openPanel(null, 'mtd')} onCallTileClick={(metric, scope) => openCallsPanel(metric, scope)} data-id="element-9" data-mp="ygd25u3tymkg" />}
            {page === 'career' && <CareerView officer={officer} data-id="element-10" data-mp="1i3b4774upjbb" />}
            {page === 'points' && <PointSystem data-id="element-11" data-mp="1m44rbyagyu35" />}
            {page === 'admin' && <AdminView data-id="element-12" data-mp="1m70o3jakzcq0" />}
          </main>
        </>}

      <LoanFilesPanel open={panelOpen} loans={officer.loans} initialStage={panelStage} initialScope={panelScope} initialSpeedBonusOnly={panelSpeedBonusOnly} onClose={() => setPanelOpen(false)} data-id="element-13" data-mp="6nmfobby8c8e" />

      <CallsPanel open={callsPanelOpen} calls={callsScope === 'today' ? officer.todayCalls : officer.calls} metric={callsMetric} dials={callsScope === 'today' ? officer.todayDials : officer.dials} callAnswerRate={callsScope === 'today' ? officer.todayCallAnswerRate : officer.callAnswerRate} scopeLabel={callsScope === 'today' ? 'Today' : 'Month to Date'} officerName={officer.name} onClose={() => setCallsPanelOpen(false)} data-id="element-14" data-mp="m6fdartmuxiy" />
    </div>;
}